import { Suspense } from "react";
import { useParams } from "react-router";

import useBrand from "../clients/brands/useBrand";
import BrandPage from "../components/BrandPage";
import BrandEditor from "../features/BrandEditor";

export default function EditBrand() {
    const { brandID } = useParams();
    return (
        <BrandPage>
            <header>
                <span>Brand</span>
            </header>
            <Suspense fallback={ <span>loading</span> }>
                <BrandEditorWithBrand
                    id={ brandID }
                />
            </Suspense>
        </BrandPage>
    );
}

function BrandEditorWithBrand(props) {
    const { id } = props;
    const brand = useBrand(id);
    return (
        <BrandEditor
            brand={ brand }
            key={ id }
        />
    );
}
